import React, { useState } from 'react';
import { WATCHES, fmt, tradeValue, insuranceValue } from '../data';
import ValueBadges from '../components/ValueBadges';

export default function PortfolioPage({ onSelectWatch }) {
  const [portfolio, setPortfolio] = useState([
    { watch_id: 'rolex-submariner-126610ln', purchase_price: 9200 },
    { watch_id: 'rolex-daytona-116500ln', purchase_price: 31000 },
    { watch_id: 'ap-royal-oak-15500st', purchase_price: 28000 },
  ]);
  const [adding, setAdding] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [purchasePrice, setPurchasePrice] = useState('');

  const items = portfolio.map(p => ({ ...p, watch: WATCHES.find(w => w.id === p.watch_id) })).filter(p => p.watch);
  const totalMarket = items.reduce((s, i) => s + i.watch.market, 0);
  const totalTrade = items.reduce((s, i) => s + tradeValue(i.watch.market), 0);
  const totalInsure = items.reduce((s, i) => s + insuranceValue(i.watch.market), 0);
  const totalCost = items.reduce((s, i) => s + i.purchase_price, 0);
  const totalGain = totalMarket - totalCost;

  function handleAdd() {
    if (!selectedId || !purchasePrice) return;
    setPortfolio(p => [...p, { watch_id: selectedId, purchase_price: Number(purchasePrice) }]);
    setSelectedId(''); setPurchasePrice(''); setAdding(false);
  }

  function handleRemove(watchId) {
    setPortfolio(p => p.filter(x => x.watch_id !== watchId));
  }

  return (
    <div style={{ position: 'relative', zIndex: 1, maxWidth: 900, margin: '0 auto', padding: 'clamp(16px,4vw,24px) clamp(12px,4vw,20px)' }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 4 }}>My Portfolio</h1>
        <p style={{ fontSize: 14, color: 'var(--text2)' }}>Track market value, trade value, and insurance across your collection.</p>
      </div>

      <div style={{ background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 10, padding: 14, marginBottom: 20, fontSize: 13, color: 'var(--text2)' }}>
        <i className="ti ti-info-circle" aria-hidden="true" style={{ marginRight: 6 }} />
        Portfolio is stored in your browser for now. Create an account to sync across devices.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 24 }}>
        {[
          { label: 'Total Market Value', value: fmt(totalMarket), color: 'var(--market)' },
          { label: 'Total Trade Value', value: fmt(totalTrade), color: 'var(--trade)' },
          { label: 'Total Insurance', value: fmt(totalInsure), color: 'var(--insure)' },
        ].map(c => (
          <div key={c.label} style={{ background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '16px 20px' }}>
            <div style={{ fontSize: 11, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>{c.label}</div>
            <div style={{ fontSize: 22, fontWeight: 600, color: c.color }}>{c.value}</div>
          </div>
        ))}
      </div>

      <div style={{ background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>Collection</div>
            <div style={{ fontSize: 12, color: totalGain >= 0 ? 'var(--up)' : 'var(--dn)', marginTop: 2 }}>
              {totalGain >= 0 ? '+' : ''}{fmt(totalGain)} total {totalGain >= 0 ? 'gain' : 'loss'}
            </div>
          </div>
          <button onClick={() => setAdding(v => !v)} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, padding: '7px 14px', borderRadius: 6, border: '0.5px solid var(--border2)', background: 'transparent', color: 'var(--text)', cursor: 'pointer' }}>
            <i className="ti ti-plus" aria-hidden="true" /> Add watch
          </button>
        </div>

        {adding && (
          <div style={{ background: 'var(--surface2)', borderRadius: 8, padding: 16, marginBottom: 16, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div style={{ flex: 2, minWidth: 200 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 5 }}>Select watch</div>
              <select value={selectedId} onChange={e => setSelectedId(e.target.value)} style={{ width: '100%', fontSize: 13, padding: '8px 10px', borderRadius: 6, border: '0.5px solid var(--border2)', background: 'var(--surface)', color: 'var(--text)', outline: 'none' }}>
                <option value="">Choose a model…</option>
                {WATCHES.filter(w => !portfolio.find(p => p.watch_id === w.id)).map(w => (
                  <option key={w.id} value={w.id}>{w.brand} {w.model} {w.year} ({w.ref})</option>
                ))}
              </select>
            </div>
            <div style={{ flex: 1, minWidth: 140 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 5 }}>Purchase price ($)</div>
              <input type="number" placeholder="e.g. 12000" value={purchasePrice} onChange={e => setPurchasePrice(e.target.value)} style={{ width: '100%', fontSize: 13, padding: '8px 10px', borderRadius: 6, border: '0.5px solid var(--border2)', background: 'var(--surface)', color: 'var(--text)', outline: 'none' }} />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={handleAdd} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 6, border: 'none', background: 'var(--text)', color: 'var(--surface)', cursor: 'pointer' }}>Add</button>
              <button onClick={() => setAdding(false)} style={{ fontSize: 13, padding: '8px 12px', borderRadius: 6, border: '0.5px solid var(--border)', background: 'transparent', color: 'var(--text2)', cursor: 'pointer' }}>Cancel</button>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {items.map(item => {
            const gain = item.watch.market - item.purchase_price;
            const gainPct = Math.round(gain / item.purchase_price * 100);
            return (
              <div key={item.watch_id} style={{ border: '0.5px solid var(--border)', borderRadius: 10, padding: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
                  <div>
                    <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 2 }}>{item.watch.brand}</div>
                    <button onClick={() => onSelectWatch(item.watch)} style={{ fontSize: 15, fontWeight: 600, background: 'none', border: 'none', color: 'var(--text)', cursor: 'pointer', padding: 0 }}>
                      {item.watch.model} <i className="ti ti-arrow-right" aria-hidden="true" style={{ fontSize: 13 }} />
                    </button>
                    <div style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'var(--font-mono)', marginTop: 1 }}>Ref. {item.watch.ref} · {item.watch.year}</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 11, color: 'var(--text3)' }}>vs purchase {fmt(item.purchase_price)}</div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: gain >= 0 ? 'var(--up)' : 'var(--dn)' }}>
                        {gain >= 0 ? '+' : ''}{fmt(gain)} ({gainPct >= 0 ? '+' : ''}{gainPct}%)
                      </div>
                    </div>
                    <button onClick={() => handleRemove(item.watch_id)} style={{ border: 'none', background: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 16, padding: 4 }} aria-label="Remove">
                      <i className="ti ti-trash" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <ValueBadges market={item.watch.market} size="sm" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
